import styled from "styled-components";

export const DivGrassDescription = styled.div`
  min-height: 100vh;
  height: fit-content;
  background: white;
  width: 100%;
`;
